"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _useVisibilityHook2 = _interopRequireDefault(require("../useVisibilityHook"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Link = function Link(props) {
  var content = props.content,
    language = props.language;
  var _useVisibilityHook = (0, _useVisibilityHook2["default"])(props),
    isClickable = _useVisibilityHook.isClickable,
    isVisible = _useVisibilityHook.isVisible;
  if (!isVisible) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  if (!content.url) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  var displayText = content.url;
  var iconUrl = '';
  if (language === 'en') {
    var _content$iconEn;
    if ('headingEn' in content) {
      displayText = content.headingEn;
    }
    if ('iconEn' in content && content !== null && content !== void 0 && (_content$iconEn = content.iconEn) !== null && _content$iconEn !== void 0 && _content$iconEn.thumbnailSmall) {
      iconUrl = content.iconEn.thumbnailSmall;
    }
  } else if (language === 'es') {
    var _content$iconEs;
    if ('headingEs' in content) {
      displayText = content.headingEs;
    }
    if ('iconEs' in content && content !== null && content !== void 0 && (_content$iconEs = content.iconEs) !== null && _content$iconEs !== void 0 && _content$iconEs.thumbnailSmall) {
      iconUrl = content.iconEs.thumbnailSmall;
    }
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].flex
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: content.url,
    className: isClickable ? '' : _style["default"].disabled,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: function onClick(event) {
      if (!isClickable) {
        event.preventDefault();
      }
    }
  }, iconUrl && /*#__PURE__*/_react["default"].createElement("img", {
    alt: displayText || 'Icon',
    src: iconUrl,
    className: _style["default"].icon
  }), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: displayText
  })));
};
var _default = exports["default"] = Link;